import type {VisitedDocumentsDataService} from './visited-documents.data-service';
import type {LogService} from 'core/logging/log.service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {Document} from 'typings/portaro.be.types';

export class KpVisitedPanelPresenter {
    public static presenterName = 'kpVisitedDocumentsPresenter';

    /*@ngInject*/
    constructor(private visitedDocumentsDataService: VisitedDocumentsDataService, private logService: LogService) {
    }

    @ngAsync()
    public async getVisitedDocuments(showLastVisited: boolean): Promise<Document[]> {
        try {
            return await this.visitedDocumentsDataService.getVisitedDocuments(showLastVisited);
        } catch (e) {
            this.logService.error('KpVisitedPanel: Unable to fetch visited documents: ', e);
            return [];
        }
    }
}